import s from './FeedPromotion.module.sass';

import { FC, useState } from 'react';
import { Button, Header, ScrollView } from '$uikit';
import { ADS, INVITE } from '$shared/constants/pages';
import { classNames, rnbr } from '$utils';
import { goTo } from '$navigation/helper';
import { IcChevron16 } from '$assets';
import { useTranslator } from '$hooks';

export const FeedPromotion: FC = () => {
  const t = useTranslator();
  const [shown, setShown] = useState<{ [index: number]: boolean }>({});

  const options = [
    {
      title: t('feed_promotion_sales_title'),
      text: t('feed_promotion_sales_text'),
    },
    {
      title: t('feed_promotion_ref_title'),
      text: t('feed_promotion_ref_text'),
      button: t('feed_promotion_ref_btn'),
      routeName: INVITE,
    },
    {
      title: t('feed_promotion_ref_ads'),
      text: t('feed_promotion_ads_text'),
      button: t('feed_promotion_ads_btn'),
      routeName: ADS,
    },
  ];

  return (
    <>
      <Header showBackButton isTransparent />
      <ScrollView>
        <div className={s.header}>
          <div className={s.headerTitle}>{t('feed_promotion_title')}</div>
          <div className={s.headerText}>{t('feed_promotion_text')}</div>
        </div>
        <div className={s.items}>
          {options.map((item, i) => (
            <div
              key={i}
              className={classNames({
                [s.item]: true,
                [s.itemShown]: !!shown[i],
              })}
            >
              <div
                className={s.itemHeader}
                onClick={() => {
                  setShown((prev) => ({
                    ...prev,
                    [i]: !prev[i],
                  }));
                }}
              >
                <div className={s.itemTitle}>
                  {i + 1}. {item.title}
                </div>
                <div className={s.itemChevron}>
                  <IcChevron16 />
                </div>
              </div>
              {!!shown[i] && (
                <>
                  <div className={s.itemText}>{rnbr(item.text)}</div>
                  {item.button && (
                    <div className={s.itemButton}>
                      <Button
                        size="small"
                        mode="secondary"
                        onClick={() => {
                          goTo(item.routeName);
                        }}
                      >
                        {item.button}
                      </Button>
                    </div>
                  )}
                </>
              )}
            </div>
          ))}
        </div>
      </ScrollView>
    </>
  );
};
